export default class PromiseUtil {
    static async delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}